var map = {
	"./audio.png": "d709",
	"./excel.png": "99d6",
	"./null.png": "d8f3",
	"./pdf.png": "c36e",
	"./txt.png": "e977",
	"./video.png": "382e",
	"./word.png": "41bc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6bf3";